export default __webpack_public_path__ + "static/media/logo-principal-gris.eda7b1c6.png";